import { useBack } from "../http";
import { AdmissionConfigurationDTO } from "../types/AdmissionConfigurationDTO";

export class AdmissionScheduleService {
	constructor() {}
	axiosInstance = useBack();

	async get() {
		try {
			const response = await this.axiosInstance.get<AdmissionConfigurationDTO>('/scheduling/config');
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter as configurações de agendamento`, error);
			return undefined;
		}
	}

	async save(value: AdmissionConfigurationDTO) {
		try {
			const response = await this.axiosInstance.post('/scheduling/config', value);
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível salvar as configurações de agendamento`, error);
			return undefined;
		}
	}
}